// src/app/pipes/count-up.pipe.ts
import { Pipe, PipeTransform, NgZone } from '@angular/core';
import { Observable, Observer, of } from 'rxjs';
import { takeWhile, finalize, switchMap, startWith } from 'rxjs/operators';

@Pipe({
  name: 'countUp',
  standalone : true
})
export class CountUpPipe implements PipeTransform {
  constructor(private ngZone: NgZone) {}

  transform(value: number, trigger$: Observable<any> = of(null), duration: number = 1000): Observable<number> {
    if (value === null || typeof value === 'undefined' || isNaN(value)) {
      return of(0);
    }

    // Determine dynamic duration based on the value
    let effectiveDuration = duration; // Default duration
    if (value <= 5) {
      effectiveDuration = 200; // Very fast for 1-5
    } else if (value <= 20) {
      effectiveDuration = 400; // Faster for 6-20
    } else if (value <= 100) {
      effectiveDuration = 600; // Medium speed for 21-100
    }
    // For values > 100, it uses the default duration (e.g., 1000ms)

    return trigger$.pipe(
      startWith(null),
      switchMap(() => {
        const start = 0;
        const end = value;
        const startTime = performance.now();

        return new Observable<number>((observer: Observer<number>) => {
          const animate = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / effectiveDuration, 1); // Use effectiveDuration
            const currentCount = Math.floor(progress * (end - start) + start);

            this.ngZone.run(() => {
              observer.next(currentCount);
            });

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              this.ngZone.run(() => {
                observer.next(end);
                observer.complete();
              });
            }
          };

          this.ngZone.runOutsideAngular(() => {
            requestAnimationFrame(animate);
          });
        }).pipe(
          finalize(() => {})
        );
      })
    );
  }
}